/**
 * Vuex mutations for the ecare module.
 *
 * @module store/modules/ecare/mutations
 */
import Vue from "vue";
import { MutationTree } from "vuex/types";

import { EcareState } from "./types";

const mutations: MutationTree<EcareState> = {
  /**
   * Sets the list of available Metabase dashboards.
   *
   * @param {EcareState} state - Module state
   * @param {Array} payload - Array of dashboard configurations
   */
  ECARE_SET_DASHBOARDS: (state, payload) => {
    Vue.set(state, "dashboards", payload);
  },

  /**
   * Sets the currently selected tab.
   *
   * @param {EcareState} state - Module state
   * @param {string} payload - Tab identifier
   */
  ECARE_SET_SELECTED_TAB: (state, payload) => {
    Vue.set(state, "selectedTab", payload);
  },

  /**
   * Sets the editor visibility state.
   *
   * @param {EcareState} state - Module state
   * @param {boolean} payload - Visibility flag
   */
  ECARE_SET_EDITOR_VISIBLE: (state, payload) => {
    Vue.set(state, "editorVisible", payload);
  },

  /**
   * Toggles the editor visibility state.
   *
   * @param {EcareState} state - Module state
   */
  ECARE_TOGGLE_EDITOR_VISIBLE: (state) =>{
    Vue.set(state, "editorVisible", !state.editorVisible);
  },
};

export default mutations;
